import * as yup from 'yup';

const identityFields = {
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces')
};

const backgroundFields = {
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed()
};

const borderFields = {
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0)
};

const titleFields = {
  title: yup.string(),
  fontSize: yup.number(),
  fontWeight: yup.string(),
  fontColor: yup.mixed()
};

const buttonSuffixFields = {
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string()
};

export const bundleSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...buttonSuffixFields
});

export const promotionSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...buttonSuffixFields,
  ...titleFields,
  collectText: yup
    .string()
    .required('Free Offer Default Text is required')
    .max(25, 'Free Offer Default Text cannot exceed the maximum characters'),
  subTitleText: yup
    .string()
    .test('max-lines', 'Maximum of two lines allowed', (value) => {
      if (!value) return true;
      return (value.match(/\n/g) || []).length <= 1;
    })
});

export const progressBarSchema = yup.object().shape({
  ...identityFields,
  ...borderFields,
  backgroundOpacity: yup.number().min(0).max(100).required('Background Opacity is required'),
  frameRadius: yup.number().min(0).required('Frame Radius is required'),
  barFillColor: yup.mixed(),
  barBackgroundColor: yup.mixed(),
  barRadius: yup.number().min(0),
  accumulatedItemImageUrl: yup.string().required('Accumulated Image is required'),
  accumulatedItemBackgroundImageUrl: yup.string().required('Accumulated Background Image is required'),
  textColor: yup.string(),
  barBackgroundImage: yup.string(),
  headerImage: yup.string()
});

export const popupSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...borderFields,
  ...titleFields,
  badgeCoverImage: yup.string()
});

export const triggeredPopupSchema = yup.object().shape({
  ...identityFields,
  ...backgroundFields,
  ...titleFields,
  widgetImage: yup.string()
});

export const rollingOfferSchema = yup.object().shape({
  ...identityFields,
  ...borderFields,
  backgroundColor: yup.mixed(),
  backgroundImage: yup.string(),
  horizontalBackgroundImage: yup.string(),
  backgroundOpacity: yup.number().min(0).max(100).required('Background opacity is required'),
  borderWidth: yup.number().min(0).max(8, 'Border width cannot exceed 8px').required('Offer border width is required'),
  collectText: yup.string().required('Free Offer Text is required'),
  arrowColor: yup.string(),
  arrowImage: yup.string(),
  headerImage: yup.string(),
  scrollArrowImage: yup.string(),
  offersBackgroundColor: yup.mixed(),
  offersBackgroundImage: yup.string(),
  enableScroll: yup.boolean()
});
